<template>
  <div>
    <my-loader v-if="isLoading" />

    <div v-else-if="hasError && !manager" class="state-block">
      <h2>Не удалось загрузить менеджера</h2>
    </div>

    <div v-else-if="manager" :class="{ cards: !isWizardReturn }">
      <div v-if="!isWizardReturn" class="header-content">
        <router-link :to="{ name: 'ManagerList' }" class="back-link">
          &larr; К списку менеджеров
        </router-link>
      </div>

      <ExecutorWizardEditLayout
        v-if="isWizardReturn"
        title="Редактирование менеджера"
        description="Измените данные менеджера-исполнителя."
      >
        <ManagerForm
          mode="edit"
          :initial-data="manager"
          :errors="formErrors"
          @update="onUpdate"
          @closeForm="closeForm"
        />
      </ExecutorWizardEditLayout>
      <div v-else class="card-item">
        <h2 class="detail-title">Менеджер #{{ manager.id }}</h2>
        <ManagerForm mode="edit" :initial-data="manager" :errors="formErrors" @update="onUpdate" />
        <guard-button :model="'managers'" :id="manager.id" />
      </div>
    </div>

    <div v-else class="state-block">
      <h2>Нет Данных</h2>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import ManagerForm from '@/components/forms/ManagerForm.vue'
import ExecutorWizardEditLayout from '@/components/UI/ExecutorWizardEditLayout.vue'
import { getManager } from '@/backend/managerApi'
import { isExecutorWizardReturn, refreshWizardItem, returnToExecutorWizard } from './executorWizardReturn'
import { useExecutorWizardStore } from '@/stores/executorWizard'

export default {
  name: 'ManagerDetail',
  components: { ManagerForm, ExecutorWizardEditLayout },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const wizard = useExecutorWizardStore()
    const isWizardReturn = isExecutorWizardReturn(route)

    const manager = ref(null)
    const isLoading = ref(false)
    const hasError = ref(false)

    const formErrors = computed(
      () => store.state.apiStorage.managers.formErrors || {},
    )

    const loadManager = async () => {
      isLoading.value = true
      hasError.value = false
      try {
        manager.value = await getManager(route.params.id)
      } catch (e) {
        console.error('[ManagerDetail] getManager failed', e)
        hasError.value = true
      } finally {
        isLoading.value = false
      }
    }

    const onUpdate = async (form) => {
      const ok = await store.dispatch('apiStorage/updateItem', {
        model: 'managers',
        form,
      })
      if (ok) {
        await loadManager()
        if (isExecutorWizardReturn(route)) {
          refreshWizardItem(wizard, route, manager.value)
          await returnToExecutorWizard(router)
        }
      }
    }

    const closeForm = () => {
      if (isExecutorWizardReturn(route)) returnToExecutorWizard(router)
    }

    onMounted(loadManager)

    return {
      manager,
      isLoading,
      hasError,
      formErrors,
      isWizardReturn,
      onUpdate,
      closeForm,
    }
  },
}
</script>

<style scoped>
.state-block {
  padding: 32px;
  color: #667085;
  text-align: center;
}

.cards {
  display: flex;
  flex-direction: column;
  padding: 15px;
}

.card-item {
  border-radius: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  padding: 15px;
}

.header-content {
  display: flex;
  justify-content: flex-start;
  margin-right: 20px;
  align-items: center;
}

.back-link {
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
}

.back-link:hover {
  text-decoration: underline;
}

.detail-title {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: bold;
}
</style>
